import { SaveButton } from "components/Buttons"
import React, { useEffect, useState } from "react"
import { Col, Row, Spinner } from "reactstrap"
import Select from "react-select"
import { connect } from "react-redux"
import Table from "components/Table"
import cellEditFactory, { Type } from "react-bootstrap-table2-editor"
import bulkPlacesListColumns from "./bulkPlacesListColumns"
import {
  getCategories,
  hideBulkUploadModal,
  setBulkUploadFlag,
  uploadBulkPlaces,
} from "store/actions"
import { getLatAndLon } from "utils"

const BulkUploadModal = ({
  places,
  categories,
  getCategories,
  hideBulkUploadModal,
  setBulkUploadFlag,
  bulkUploadFlag,
  uploadBulkPlaces,
  vendorId,
  selectedBusinesUnit,
}) => {
  const [placesData, setPlacesData] = useState([])
  const [selectedCategory, setSelectedCategory] = useState()
  const [sliceNum, setSliceNum] = useState(25)

  useEffect(() => {
    setPlacesData(places?.map((place, index) => ({ ...place, id: index })))
  }, [places])

  useEffect(() => {
    getCategories({ type: 2 })
  }, [])

  const removePlaceFromList = selectedPlace => {
    setPlacesData(prevState => {
      const newState = prevState.filter(
        place => selectedPlace?.id !== place?.id
      )
      return newState
    })
  }

  const uploadHanler = async places => {
    setBulkUploadFlag(true)
    let preparedPlaces = []
    for (const place of places) {
      const updatedPlace = JSON.parse(JSON.stringify(place))
      try {
        const googleApiResponse = await getLatAndLon(place)
        if (
          googleApiResponse &&
          googleApiResponse?.results &&
          googleApiResponse?.results[0]?.geometry
        ) {
          updatedPlace.lat = googleApiResponse.results[0].geometry.location.lat
          updatedPlace.lon = googleApiResponse.results[0].geometry.location.lng
        }
        if (
          googleApiResponse &&
          googleApiResponse.results &&
          googleApiResponse.results[0] &&
          googleApiResponse.results[0].address_components &&
          (!updatedPlace.country_code || !updatedPlace.zip_code)
        ) {
          googleApiResponse.results[0].address_components.forEach(item => {
            if (
              item.types.indexOf("postal_code") !== -1 &&
              !updatedPlace.zip_code
            ) {
              updatedPlace.zip_code = item.long_name
            }
            if (
              item.types.indexOf("country") !== -1 &&
              !updatedPlace.country_code
            ) {
              updatedPlace.country_code = item.short_name
            }
          })
        }
        preparedPlaces.push(updatedPlace)
        setPlacesData(prevState => {
          const newState = prevState.map(place => {
            if (place.id === updatedPlace.id) {
              return updatedPlace
            }
            return place
          })
          return newState
        })
      } catch (error) {
        console.log("ERROR", error)
      }
    }
    uploadBulkPlaces({
      business_unit_id: selectedBusinesUnit?.value,
      category_id: selectedCategory?.value,
      places: preparedPlaces,
      vendor_id: vendorId,
    })
  }

  return (
    <React.Fragment>
      <div className="modal-header">
        <h5 className="modal-title mt-0">Add {placesData?.length} Places</h5>
        <button
          type="button"
          onClick={hideBulkUploadModal}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Row className="d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              content="Add Places"
              type="button"
              onClick={() => {
                uploadHanler(placesData)
              }}
              disabled={placesData?.length === 0}
            />
          </Col>
        </Row>
        {bulkUploadFlag && (
          <Row className="d-flex justify-content-center">
            <Spinner color="primary" />
          </Row>
        )}
        <Row className="my-3">
          <Col xs="auto" className="mt-2">
            Select a Category for all places which don't have one:
          </Col>
          <Col xs="auto" className="my-1">
            <div style={{ width: "250px" }}>
              <Select
                value={selectedCategory}
                onChange={v => setSelectedCategory(v)}
                options={categories?.map(category => ({
                  value: category?.id,
                  label: category?.name,
                }))}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table
              columns={bulkPlacesListColumns(removePlaceFromList)}
              data={placesData?.slice(0, sliceNum)}
              cellEdit={cellEditFactory({ mode: "click", blurToSave: true })}
              headerWrapperClasses="table"
              classes="table-borderless"
            />
          </Col>
        </Row>
        {sliceNum < placesData?.length && (
          <Row className="d-flex justify-content-center">
            <Col xs="auto">
              <SaveButton
                type="button"
                content="Load More"
                onClick={() => setSliceNum(sliceNum + 25)}
              />
            </Col>
          </Row>
        )}
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  categories: state.Categories.categories,
  bulkUploadFlag: state.PlacesList.bulkUploadFlag,
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  getCategories: values => dispatch(getCategories(values)),
  hideBulkUploadModal: () => dispatch(hideBulkUploadModal()),
  setBulkUploadFlag: value => dispatch(setBulkUploadFlag(value)),
  uploadBulkPlaces: values => dispatch(uploadBulkPlaces(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BulkUploadModal)
